import "@/front/plugins/packeta/packeta";

document.addEventListener("DOMContentLoaded", () => {
	$('.form-cart-data-submit').off('click').on('click', function (e) {
		$('input[type="submit"][name="send"]').click();
		e.preventDefault();
		e.stopPropagation();
	});

	$('.delivery-option').off('click').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();

		$('.delivery-option').removeClass('selected');
		$(this).addClass('selected');
		$(this).find('input').prop('checked', true);

		$('.payment-option').removeClass('selected').addClass('d-none');
		$('.payment-option input[type="radio"]').prop('checked', false);

		const acceptablePaymentIds = $(this).data('payment-ids');

		for (let acceptablePaymentId in acceptablePaymentIds) {
			if (acceptablePaymentIds.hasOwnProperty(acceptablePaymentId)) {
				const paymentOption = $('[data-payment-id="' + acceptablePaymentIds[acceptablePaymentId] + '"]');
				paymentOption.removeClass('d-none');
			}
		}

		if ($(this).hasClass('packeta-open')) {
			showPacketaWidget();
		}

		if ($(this).hasClass("dpd-open")) {
			showDpdWidget();
		}
	});

	$('.payment-option').off('click').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();

		$('.payment-option').removeClass('selected');
		$(this).addClass('selected');
		$(this).find('input').prop('checked', true);
	});

	function showSelectedPickupPoint(point) {
		if (point) {
			const name = point.name + ' (' + point.place + ')';
			const id = point.id;

			$('.packeta-branch-name').html(name);
			$('input[name="vm_name"]').val(name);
			$('input[name="vm_code"]').val(id);
		}
	}

	function showPacketaWidget()
	{
		const packetaApiKey = 'a6d31e9802903ad2';
		Packeta.Widget.pick(packetaApiKey, showSelectedPickupPoint, {country: 'sk', language: 'sk'});
	}

	function showDpdWidget()
	{
		const $modal = $("#dpd-modal")
		$modal.modal('show');

		window.addEventListener("message", (event) => {
			if(event.data.dpdWidget) {
				if (event.data.dpdWidget.message === "widgetClose") {
					$modal.modal('hide')
				} else {
					const point = event.data.dpdWidget;
					const name = point.contactInfo.name + ", " + point.location.address.street + ", " + point.location.address.zip + " " + point.location.address.city;
					const id = point.id;

					$(".dpd-branch-name").html(name);
					$("input[name=\"vm_name\"]").val(name);
					$("input[name=\"vm_code\"]").val(id);

					$modal.modal('hide')
				}
			}
		}, false);
	}

});
